export default __webpack_public_path__ + "static/media/dennyKlein.4b19b305.jpg";